<i18n>
{
	"en": {
		"tripType": "Trip Type",
		"selectTripTypes": "Select Trip Types",
		"distribution": "Distribution",
		"external": "External",
		"linehaul": "Linehaul",
		"tripTypesSelected": "All trip types | {count} trip type selected | {count} trip types selected"
	},
	"no": {
		"tripType": "Turtype",
		"selectTripTypes": "Velg turtyper",
		"distribution": "Distribusjon",
		"external": "Ekstern",
		"linehaul": "Langtransport",
		"tripTypesSelected": "Alle turtyper | {count} turtype valgt | {count} turtyper valgt"
	}
}
</i18n>
<template>
	<t-select
		:items="tripTypesWithExternal"
		:label="$t('tripType')"
		:selectedItems="selectedItems"
		:disabled="disabled"
		relative
		width="100%"
		@change="onChange"
	>
		<template v-slot:displayedValue="{popoverShow}">
			{{ popoverShow ? $t('selectTripTypes') : $tc('tripTypesSelected', selectedItems.length)}}
		</template>
		<template v-slot:optionItem="slotProps">
			<t-menu-combobox-option-item
				:value="slotProps.item"
				:selected="slotProps.isSelected"
			>
				<div class="list-item">
					<t-timpex-icon
						:icon="getTripTypeIcon(slotProps.item.internalCode)"
						type="bp"
						color="neutral"
					/>
					<div>{{ slotProps.item.description }}</div>
				</div>
			</t-menu-combobox-option-item>
		</template>
	</t-select>
</template>

<script>
import { tripTypeIcon } from '@/core';
import { mapState, mapActions } from './store/tripTypes.store';

export default {
	name: 'TripTypesSelect',
	props: { selectedItems: Array },
	computed: {
		...mapState(['tripTypes']),
		disabled() {
			return !this.tripTypes || this.tripTypes.length === 0;
		},
		tripTypesWithExternal() {
			return [...this.tripTypes, { id: 'external', description: 'External', internalCode: 'external' }];
		}
	},
	mounted() {
		this.getTripTypes();
	},
	methods: {
		...mapActions(['getTripTypes']),
		getTripTypeIcon(iconId) {
			return tripTypeIcon(iconId);
		},
		onChange(item) {
			this.$emit('change', { id: item.id, value: item.description, iconType: 'bp', icon: this.getTripTypeIcon(item.internalCode) });
		}
	},
};

</script>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;

	> div {
		margin-left: 10px;
	}
}
</style>

